import { render, staticRenderFns } from "./gw-main.vue?vue&type=template&id=7f8668fa"
import script from "./gw-main.vue?vue&type=script&lang=js"
export * from "./gw-main.vue?vue&type=script&lang=js"
import style0 from "./gw-main.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports